// Tipos para el módulo Blog del admin panel

export interface BlogType {
    id: string;
    name: string;
    slug: string;
    color: string;
    sort_order: number;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export type BlogPostStatus = 'draft' | 'review' | 'enabled' | 'disabled';

export type BlogLocale = 'es' | 'en';

export interface BlogPostListItem {
    id: string;
    type_id: string | null;
    type_name: string | null;
    type_slug: string | null;
    type_color: string | null;
    slug: string;
    title: string;
    excerpt: string | null;
    main_image_url: string | null;
    main_image_position: 'top' | 'side';
    status: BlogPostStatus;
    locale?: BlogLocale;
    translation_of_id?: string | null;
    translation_inverse_id?: string | null;
    translation_inverse_slug?: string | null;
    hero_credit_username?: string | null;
    created_at: string;
    updated_at: string;
    has_excerpt?: boolean;
    has_body?: boolean;
    has_image?: boolean;
    has_seo?: boolean;
    completeness?: number;
    is_rich?: boolean;
}

export interface BlogPostDetail {
    id: string;
    type_id: string | null;
    type_name: string | null;
    type_slug: string | null;
    type_color: string | null;
    slug: string;
    title: string;
    excerpt: string | null;
    body_html: string;
    main_image_url: string | null;
    main_image_position: 'top' | 'side';
    status: BlogPostStatus;
    meta_title: string | null;
    meta_description: string | null;
    og_image_url: string | null;
    author: string | null;
    reviewer: string | null;
    locale: BlogLocale;
    translation_of_id: string | null;
    translation_inverse_id?: string | null;
    translation_inverse_slug?: string | null;
    hero_credit_username: string | null;
    created_at: string;
    updated_at: string;
    has_excerpt?: boolean;
    has_body?: boolean;
    has_image?: boolean;
    has_seo?: boolean;
    completeness?: number;
    is_rich?: boolean;
}

/** Alias para hooks que devuelven post completo */
export type BlogPost = BlogPostDetail;

export interface BlogPostFormData {
    type_id: string | null;
    slug: string;
    title: string;
    excerpt: string;
    body_html: string;
    main_image_url: string;
    main_image_position: 'top' | 'side';
    status: BlogPostStatus;
    meta_title: string;
    meta_description: string;
    og_image_url: string;
    locale: BlogLocale;
    translation_of_id: string | null;
    hero_credit_username: string;
}

export const EMPTY_BLOG_POST_FORM: BlogPostFormData = {
    type_id: null,
    slug: '',
    title: '',
    excerpt: '',
    body_html: '',
    main_image_url: '',
    main_image_position: 'top',
    status: 'draft',
    meta_title: '',
    meta_description: '',
    og_image_url: '',
    locale: 'es',
    translation_of_id: null,
    hero_credit_username: '',
};

export interface BlogPostsStats {
    total: number;
    draft: number;
    review: number;
    enabled: number;
    incomplete: number;
}

export interface BlogPostsListResult {
    items: BlogPostListItem[];
    total: number;
    limit: number;
    offset: number;
}

export interface BlogBatchResultItem {
    index: number;
    slug: string | null;
    title: string | null;
    id: string | null;
    filename: string | null;
    status: string;
    reason: string | null;
    action: string | null;
}

export interface BlogBatchResult {
    dryRun: boolean;
    applied: number;
    total: number;
    items: BlogBatchResultItem[];
}
